import { render, staticRenderFns } from "./ClassroomForm.vue?vue&type=template&id=95fcd5da"
import script from "./ClassroomForm.vue?vue&type=script&lang=js"
export * from "./ClassroomForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports